import { Text } from "@certa/icons/components/Text";
import { Tag } from "@certa/icons/components/Tag";
import { Date } from "@certa/icons/components/Date";
import { Database } from "@certa/icons/components/Database";
import type { ObjectReportColumn } from "./transformers/schemas";
import { Badge } from "@certa/icons/components/Badge";

export enum ObjectReportColumnFieldTags {
  OBJECT_UID = "uid",
  OBJECT_NAME = "name",
  OBJECT_LOGO = "logo",
  OBJECT_STATUS = "status_tag",
  OBJECT_STATUS_NAME = "status_name",
  OBJECT_STATUS_COLOR_CODE = "status_color_code",
  OBJECT_CREATED_AT = "created_at",
  OBJECT_UPDATED_AT = "updated_at",
  BADGE_TAGS = "badge_tags"
}

export type ObjectReportSmartColumnType = {
  title: {
    id: string;
    defaultMessage: string;
  };
  icon: React.ComponentType<any>;
  value: ObjectReportColumnFieldTags;
};

export const SMART_COLUMNS: ObjectReportSmartColumnType[] = [
  {
    title: {
      id: "objectReports.objectName",
      defaultMessage: "Name"
    },
    icon: Text,
    value: ObjectReportColumnFieldTags.OBJECT_NAME
  },
  {
    title: {
      id: "objectReports.objectStatus",
      defaultMessage: "Status"
    },
    icon: Tag,
    value: ObjectReportColumnFieldTags.OBJECT_STATUS_NAME
  },
  {
    title: {
      id: "objectReports.objectCreatedAt",
      defaultMessage: "Created At"
    },
    icon: Date,
    value: ObjectReportColumnFieldTags.OBJECT_CREATED_AT
  },
  {
    title: {
      id: "objectReports.objectUpdatedAt",
      defaultMessage: "Updated At"
    },
    icon: Date,
    value: ObjectReportColumnFieldTags.OBJECT_UPDATED_AT
  },
  {
    title: {
      id: "objectReports.objectUID",
      defaultMessage: "Object UID"
    },
    icon: Database,
    value: ObjectReportColumnFieldTags.OBJECT_UID
  },
  {
    title: {
      id: "objectReports.badges",
      defaultMessage: "Badges"
    },
    icon: Badge,
    value: ObjectReportColumnFieldTags.BADGE_TAGS
  }
];

export const DEFAULT_OBJECT_REPORT_COLUMNS: ObjectReportColumn[] = [
  {
    object_tag: "", // Will be set dynamically based on selected object type
    field_tag: ObjectReportColumnFieldTags.OBJECT_NAME,
    label: "Name"
  },
  {
    object_tag: "",
    field_tag: ObjectReportColumnFieldTags.OBJECT_LOGO,
    label: "Logo",
    extra_json: {
      is_hidden: true
    }
  },
  {
    object_tag: "",
    field_tag: ObjectReportColumnFieldTags.OBJECT_STATUS_NAME,
    label: "Status"
  },
  {
    object_tag: "",
    field_tag: ObjectReportColumnFieldTags.OBJECT_STATUS_COLOR_CODE,
    label: "Status Color",
    extra_json: {
      is_hidden: true // Hidden column to provide color data
    }
  },
  {
    object_tag: "",
    field_tag: ObjectReportColumnFieldTags.OBJECT_CREATED_AT,
    label: "Created At"
  }
];

export const MAX_TITLE_LENGTH = 75;
export const MAX_DESCRIPTION_LENGTH = 300;
